import { toggleSingleSceneObject } from "../../togglers";
import { OFFSET_GLIDERS } from "./pos_map";

export const changeOpornoeKoltso = (isChecked) => {
    const name = `stul__sta__opornoe_koltso`;

    let posY = 10;

    const isOporaGlaydery = servObj.activeOpora.some((opora) => opora.userData.type === "glaydery");
    if (isOporaGlaydery) {
        posY -= OFFSET_GLIDERS.Y;
    }

    toggleSingleSceneObject({
        allObjects: servObj.allOpornoeKoltso,
        activeArray: servObj.activeOpornoeKoltso,
        name,
        isChecked,
        position: { y: posY },
        userData: { name },
    });
};
